import { render } from "./MainPhysicalInventory.vue?vue&type=template&id=0aaf085e&scoped=true"
import script from "./MainPhysicalInventory.vue?vue&type=script&lang=js"
export * from "./MainPhysicalInventory.vue?vue&type=script&lang=js"

import "./MainPhysicalInventory.vue?vue&type=style&index=0&id=0aaf085e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaf085e"]])

export default __exports__